module.exports = __webpack_public_path__ + "static/gallery-5-59b0ddf41c47cafca92edfbeae7153a7.jpg";